<template>
  <div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Territory</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <multiselect
          class="selectExample"
          v-model="selectedTerritory"
          :options="optionTerritory"
          :multiple="false"
          :allow-empty="false"
          :group-select="false"
          :max-height="100"
          :limit="3"
          placeholder="Type to search"
          :searchable="true"
          :custom-label="customLableTerritory"
        />
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Sales Supervisor</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <multiselect
          class="selectExample"
          v-model="selectedSalesSupervisor"
          :options="optionSalesSupervisor"
          :multiple="false"
          :allow-empty="false"
          :group-select="false"
          :max-height="100"
          :limit="3"
          placeholder="Type to search"
          :searchable="true"
          :custom-label="customLableSalesSupervisor"
          @search-change="handleSearchSupervisor"
        />
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Sales ID/Name</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <multiselect
          class="selectExample"
          v-model="selectedSales"
          :options="optionSales"
          :multiple="false"
          :allow-empty="false"
          :group-select="false"
          :max-height="100"
          :limit="3"
          placeholder="Type to search"
          :searchable="true"
          :custom-label="customLableSales"
          @search-change="handleSearchSales"
        />
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Date</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <datepicker
              name="date_start"
              format="yyyy-MM-dd"
              :inline="false"
              v-model="dateStart"
              placeholder="Select Date"
            ></datepicker>
      </div>
    </div>
    <div class="vx-row mb-6" style="width:50%">
        <div class="vx-col sm:w-1/3 w-full flex items-center">
        </div>
        <div class="vx-col sm:w-2/3 w-full">
            <vs-button color="primary" @click="handleFilter()">Filter</vs-button>
        </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/1 w-full mb-base">
        <data-table
          :territoryID="this.selectedTerritory ? this.selectedTerritory.id : 0"
          :salesSupervisorID="this.selectedSalesSupervisor ? this.selectedSalesSupervisor.personal_id : 0"
          :salesID="this.selectedSales ? this.selectedSales.personal_id : 0"
          :dateStart="this.formattedDateStart"
          :baseUrl="this.baseUrl"
          :draw="draw"
          :status="this.status"
          :is-get-data="this.isGetData"
        ></data-table>
      </div>
    </div>
</div>
</template>
<script>
import DataTable from "./component/Table.vue";
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    DataTable,
    Datepicker,
  },
  data() {
    return {
      uploadReady: true,
      baseUrl: "/api/sfa/v1/daily-closing-salesman",
      optionTerritory: [],
      selectedTerritory: null,
      optionSalesSupervisor: [],
      selectedSalesSupervisor: null,
      optionSales: [],
      selectedSales: null,
      dateStart: new Date(),
      draw: 0,
      territoryID: 0,
      status: 3,
      isGetData: false,
      ALL_OPTION: {
        personal_id: 0,
        personal_name: "All",
        persona_work_id_number: "ALL"
      },
    };
  },
  methods: {
    getTerritory() {
      this.$vs.loading();
      this.$http
        .get("api/sfa/v1/route-plan/territory", {
          params: {
            length: 0,
            order: "name",
            sort: "asc",
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            if (resp.data.records) {
              this.optionTerritory = resp.data.records;
              if (this.territoryID !== 0) {
                const found = this.optionTerritory.find(
                  (t) => t.id === this.territoryID
                );

                if (found) {
                  this.selectedTerritory = found;
                  console.log("SELECTED TERRITORY",this.selectedTerritory)
                }
              }
            } else {
              this.optionTerritory = [];
              this.selectedTerritory = null;
            }
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    getSalesSupervisor(params) {
      this.$vs.loading();
      this.$http
        .get("api/sfa/v1/monitoring-dashboard/supervisor", {
          params: params,
        })
        .then((resp) => {
          if (resp.code == 200) {
            if (resp.data.records != null) {
              let optionSalesSupervisor = [];
              optionSalesSupervisor.push(this.ALL_OPTION);

              if (resp.data.records != null) {
                resp.data.records.forEach((item) => {
                  optionSalesSupervisor.push(item);
                });
              }

              this.optionSalesSupervisor = optionSalesSupervisor;

              this.selectedSalesSupervisor = this.ALL_OPTION;
            } else {
              this.optionSalesSupervisor = [];
            }
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
            console.log(resp.data);
          }
        });
    },
    getSales(params) {
      this.$vs.loading();
      this.$http
        .get("api/sfa/v1/personal-territory/salesman-with-territory", {
          params: params,
        })
        .then((resp) => {
          console.log("RESP SALES",resp)
          if (resp.code == 200) {
            if (resp.data.records != null) {
              let optionSales = [];
              optionSales.push({
                personal_id: 0,
                personal: {
                  code_external: "ALL",
                  name: "All"
                }
              });

              if (resp.data.records != null) {
                resp.data.records.forEach((item) => {
                  optionSales.push(item);
                });
              }

              this.optionSales = optionSales;
              if(!this.selectedSales){
                this.selectedSales = optionSales[0];
              }
            } else {
              this.optionSales = [];
            }
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
            console.log(resp.data);
          }
        });
    },
    handleSearchSupervisor(search) {
        if (!this.selectedTerritory) return

        const params = {
            territory_ids: [this.selectedTerritory.id],
            search: search,
            length: search ? 0 : 5,
        }

        this.getSalesSupervisor(params)
    },
    handleSearchSales(search) {
        if (!this.selectedSalesSupervisor) return

        const params = {
            territory_id: this.selectedTerritory.id,
            sales_spv_ids: this.selectedSalesSupervisor,
            search: search,
            length: search ? 0 : 5,
        }

        this.getSales(params)
    },
    customLableTerritory({ code, name }) {
      return `${code} ${name}`;
    },
    customLableSalesSupervisor(optionSalesSupervisor) {
      if (optionSalesSupervisor.personal_id === 0) return "ALL";
      return `${optionSalesSupervisor.persona_work_id_number} - ${optionSalesSupervisor.personal_name}`;
    },
    customLableSales(optionSales) {
      if (optionSales.personal_id === 0) return "ALL";
      return `${optionSales.personal.code_external} - ${optionSales.personal.name}`;
    },
    handleFilter() {
        this.draw++;
        this.isGetData = true
    },
  },
  mounted() {
    this.territoryID = this.$userLogin.territory_id
    this.getTerritory();
  },
  watch: {
    selectedTerritory(val) {
        if (!val) {
            this.optionSalesSupervisor = []
            this.selectedSalesSupervisor = null
            return
        }

        const params = {
            territory_ids: [val.id],
            length: 5,
        }

        this.selectedSalesSupervisor = null
        this.optionSalesSupervisor = []
        this.selectedSales = null
        this.optionSales = []

        this.getSalesSupervisor(params)
    },
    selectedSalesSupervisor(val){
        console.log("val supervisor",val)
        const params = {
            territory_id: this.selectedTerritory.id,
            sales_spv_id: val.personal_id,
            length: 5,
        }

        this.selectedSales = null
        this.optionSales = []

        this.getSales(params)
    },
    selectedSales(val){
        console.log("val sales",val)
    }
  },
  computed: {
    formattedDateStart() {
      if (!this.dateStart) return null

      const d = new Date(this.dateStart)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, "0")
      const day = String(d.getDate()).padStart(2, "0")

      return `${year}-${month}-${day}`
    }
  }
};
</script>

<style scoped>
.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter, .core-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.core {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}
</style>
